import React from "react"
import { config } from "../../../config"

export default function Card({
  type,
  content,
  className,
  onClick,
  upperCase = false,
}) {
  if (type === "img") {
    return (
      <div className={`grid-card ${className}`} onClick={onClick}>
        <img
          alt={content}
          className={`img-thumbnail img-fluid grid-img`}
          src={`${config.imgUrl}/words/${content}`}
        />
      </div>
    )
  } else {
    return (
      <div className={`grid-card ${className}`} onClick={onClick}>
        <p className="">{upperCase ? content.toUpperCase() : content}</p>
      </div>
    )
  }
}
